import { Col, Form, Input, Modal, notification, Row } from 'antd';
import { localize } from 'mixins/helpers';
import Button from 'mixins/ui/button/button';
import React, { useState } from 'react';
import ScannerCodeImg from './assets/scannerCode.svg';
import QrCode from './QrCodeScanner.jsx';
import Recaptcha from '/react4xp/mixins/ui/recaptcha/recaptcha';

const ByScanner = ({
    ukmType,
    setUkmType,
    clearForm,
    loading,
    onFinish,
    form,
    setSearchType,
    captchaRef,
    ...props
}) => {
    const { usid } = props.config;

    const [showScanner, setShowScanner] = useState(false);
    const [showAlert, setShowAlert] = useState(false);

    const onNewScanResult = (decodedText: string, decodedResult?: any) => {
        form.setFieldsValue({
            usid: decodedResult?.decodedText,
        });
        setShowScanner(false);
        notification.success({
            message: localize('find-ukm-barcode-scaned-successfully', props.translations),
            duration: 3,
        });
    };

    return (
        <>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Row gutter={16}>
                    <Col
                        xs={24}
                        md={16}
                        lg={8}
                    >
                        <Form.Item
                            style={{
                                position: 'relative',
                            }}
                            label={usid}
                            name="usid"
                            rules={[
                                {
                                    required: true,
                                    message: localize('error.ukm-id', props.commonTranslations),
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder={localize(
                                    'placeholder.input',
                                    props.commonTranslations
                                )}
                            />
                        </Form.Item>
                        <span
                            onClick={() => setShowScanner(true)}
                            className="scannerBtn"
                        >
                            <ScannerCodeImg />
                        </span>
                    </Col>
                </Row>

                {showScanner && (
                    <Modal
                        open={showScanner}
                        cancelText={localize('placeholder.input', props.commonTranslations)}
                        onCancel={() => setShowScanner(false)}
                        style={{
                            margin: '0 auto',
                        }}
                        width={400}
                        footer={[
                            <Button
                                key="back"
                                onClick={() => setShowScanner(false)}
                            >
                                {localize('button.close', props.commonTranslations)}
                            </Button>,
                        ]}
                    >
                        <Col>
                            <span>
                                {localize('find-ukm-bring-barcode-to-camera', props.translations)}
                            </span>
                        </Col>
                        <QrCode
                            fps={10}
                            qrbox={250}
                            disableFlip={false}
                            qrCodeSuccessCallback={onNewScanResult}
                            setShowAlert={setShowAlert}
                            setShowScanner={setShowScanner}
                        />
                    </Modal>
                )}

                <Recaptcha
                    ref={captchaRef}
                    lang={props.lang}
                />

                <hr className="my-3" />

                <Row gutter={{ xs: 8, md: 16 }}>
                    <Col>
                        <Button onClick={clearForm}>
                            {localize('button.reset', props.commonTranslations)}
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            color="gold"
                            htmlType="submit"
                            loading={loading}
                        >
                            {localize('button.find', props.commonTranslations)}
                        </Button>
                    </Col>
                </Row>

                <p
                    style={{
                        marginTop: 10,
                    }}
                >
                    {loading
                        ? localize('find-ukm-wait-server-request', props.translations)
                        : '* ' + localize('find-ukm-required-webcam', props.translations)}
                </p>
            </Form>

            {showAlert && (
                <Modal
                    open={showAlert}
                    cancelText={localize('button.check-manually', props.commonTranslations)}
                    onCancel={() => setShowAlert(false)}
                    style={{
                        margin: '0 auto',
                    }}
                    width={600}
                    footer={[
                        <Button
                            key="back"
                            onClick={() => {
                                setShowScanner(true);
                                setShowAlert(false);
                            }}
                        >
                            {localize('button.repeat', props.commonTranslations)}
                        </Button>,
                        <Button
                            key="back"
                            type="primary"
                            color="gold"
                            onClick={() => {
                                setShowAlert(false);
                                setSearchType('byHand');
                            }}
                        >
                            {localize('button.check-manually', props.commonTranslations)}
                        </Button>,
                    ]}
                >
                    <Col>
                        <span>{localize('find-ukm-scanning-difficults', props.translations)}</span>
                    </Col>
                    <Col>
                        <ul>
                            <li>{localize('find-ukm-not-damaged', props.translations)}</li>
                            <li>{localize('find-ukm-focus-camera ', props.translations)}</li>
                            <li>{localize('find-ukm-access-internet', props.translations)}</li>
                            <li>{localize('find-ukm-use-manual-input', props.translations)}</li>
                        </ul>
                    </Col>
                </Modal>
            )}
        </>
    );
};

export default ByScanner;
